import DealHelper from "@js/helpers/DealHelper";
import { ODataHelper } from "@js/helpers/ODataHelper";
import {
  BridgingDeal,
  CommercialDeal,
  DealClient,
  DevelopmentFinanceDeal,
  LocationEnum,
  OrganisationLinkClient,
} from "@src/apis/ModularClient";

export class CriteriaController<T extends BridgingDeal | CommercialDeal | DevelopmentFinanceDeal> {
  dealDto: T;
  dataLoading: boolean = false;

  //Postcode properties
  showPostcodeErrorMessage: boolean = false;
  postcodeErrorMsg: string;
  previouslySelectedLocation: LocationEnum;

  orgLinkId: number = null;

  static $inject = ["DealClient", "$routeParams", "ODataHelper", "OrganisationLinkCrudClient"];

  constructor(
    public dealService: DealClient,
    public $routeParams: ng.route.IRouteParamsService,
    public odataHelper: ODataHelper,
    public organisationLinkClient: OrganisationLinkClient,
  ) {}

  getRegionByPostcode() {
    if (this.dealDto.postcodeSearchString && this.dealDto.postcodeSearchString.replace(" ", "").length >= 2) {
      if (DealHelper.isValidPostcodeString(this.dealDto.postcodeSearchString)) {
        this.dataLoading = true;
        this.dealService
          .getRegionByPostcode(this.dealDto.postcodeSearchString)
          .then((response) => {
            if (response.location != null) {
              this.dealDto.locations = response.location;
              this.showPostcodeErrorMessage = false;
            } else {
              this.postcodeErrorMsg = response.postCodeErrorMessage;
              this.showPostcodeErrorMessage = true;
              if (this.dealDto.locations) this.dealDto.locations = null;
            }
          })
          .finally(() => {
            this.dataLoading = false;
          });
      } else {
        this.postcodeErrorMsg = "At least one letter and one number must be entered e.g. SW1.";
        this.showPostcodeErrorMessage = true;
        if (this.dealDto.locations) this.dealDto.locations = null;
      }
    } else {
      if (this.dealDto.locations) this.dealDto.locations = null;
    }
  }

  onHasPostcodeChange() {
    if (!this.dealDto.hasPostcode) {
      this.showPostcodeErrorMessage = false;
      this.dealDto.postcodeSearchString = null;
      this.dealDto.locations = this.previouslySelectedLocation;
    } else {
      this.previouslySelectedLocation = this.dealDto.locations;
      this.dealDto.locations = null;
    }
  }

  async getProductFamiliesByUniqueId() {
    const response = await this.organisationLinkClient.getOrganisarionlinkUniqueId(this.$routeParams.uniqueId);
    this.orgLinkId = response.id;
  }
}
